module.exports = __webpack_public_path__ + "images/emoji/house_with_garden.055120b356f21b8cc2ea.png";